import { render } from "./QuadrantPage.vue?vue&type=template&id=4aaec3f6&ts=true"
import script from "./QuadrantPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./QuadrantPage.vue?vue&type=script&lang=ts&setup=true"

import "./QuadrantPage.vue?vue&type=style&index=0&id=4aaec3f6&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/agents/pages/quadrant/QuadrantPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4aaec3f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4aaec3f6', __exports__)) {
    api.reload('4aaec3f6', __exports__)
  }
  
  module.hot.accept("./QuadrantPage.vue?vue&type=template&id=4aaec3f6&ts=true", () => {
    api.rerender('4aaec3f6', render)
  })

}


export default __exports__